// extracted by mini-css-extract-plugin
export default {"navigationBlockWrapper":"styles_navigationBlockWrapper__ssmVD","selected":"styles_selected__00AfS"};